import React from "react";
import { Outlet } from "react-router-dom";

const AllHomeDesireRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AllHomeDesireRoot;
